import React from "react";
import Works from "./Works"; // your services component

const Service = () => {
  return (
    <section id="work" >
      <h2 className="works-title">Our Work</h2>
      <Works />
    </section>
  );
};

export default Service;